import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Marketing from './Components/Pages/Marketing';
import Index from './Components/Pages/Index';
import Privacy from './Components/Pages/Privacy';
import TermsAndconditions from './Components/Pages/TermsAndconditions';
import Main from './main';
import MainDashboard from './Components/Enhancement/Main';
import EditUser from './pages/userEdit/[id]';
import AppRedirect from './Components/Pages/AppRedirect';
import CreateRepresentative from './Components/CreateNewRepresentative/CreateRepresentative';
import ChildSafetyStandards from './Components/Pages/ChildSafetyStandards';
import Dashboard from './Components/Dashboard/Dashboard';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/create-representative" element={<CreateRepresentative />} />
        <Route path="/app" element={<AppRedirect />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<TermsAndconditions />} />
        <Route path="/child-safety-standards" element={<ChildSafetyStandards />} />
        <Route path="/admin" element={<Login />} />
        <Route path="/main" element={<MainDashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/userEdit/:id" element={<EditUser />} /> 

      </Routes>
    </Router>
  );
}

export default App;
